import React from "react";
import AntTabs, { TabsProps } from "antd/lib/tabs";
import "./tabs.less";

export const Tabs: React.FC<TabsProps> = (props) => <AntTabs {...props} />;
export const { TabPane } = AntTabs;
